import React, { useState } from 'react';
import Button from '../../components/button/Button.js';
import styles from '../../assets/css/layoutMain/companyProfile/companyProfiles.module.css';

import images from '../../assets/images';
import CardPeoples from '../../components/cards/CardPeoples.js';

const Vendor = () => {
    const [tap, setTap] = useState(2);
    const [showTaps, setShowTaps] = useState(false);

    return (
        <>
            <div className={styles.companyProfile}>
                <section className={styles.companyProfileInfo}>
                    <div className={styles.companyProfileBackground}>
                        <img
                            className={styles.companyProfileBackgroundImg}
                            src="https://ladefinicion.com/wp-content/uploads/2019/08/paisaje-natural.jpg"
                            alt="backgroundimg"
                        />

                        <div className={styles.wrapperUserPhoto}>
                            <img
                                className={styles.companyProfileUserPhoto}
                                src="https://cdn.pixabay.com/photo/2017/11/10/05/48/user-2935527_1280.png"
                                alt="user"
                            />
                        </div>
                    </div>

                    <div className={styles.companyProfileUser}>
                        <div className={styles.companyProfileBtn}>
                            <Button
                                fontSize="0.75rem"
                                icon={images.messager2}
                                alignImg="left"
                                classs="btnRoundedTransparent"
                            />
                            <Button
                                fontSize="0.75rem"
                                classs="btnOutlineMain"
                                text="Following"
                            />
                            <Button
                                fontSize="0.75rem"
                                icon={images.settingMain}
                                alignImg="left"
                                classs="btnRoundedTransparent"
                            />
                        </div>
                        <h3 className={styles.companyProfileUserName}>
                            CampfireSocial
                        </h3>
                        <div className={styles.btnMt}>
                            <Button
                                fontSize="0.75rem"
                                icon={images.web}
                                alignImg="left"
                                classs="btnMain"
                                text="Visit Provider’s Website"
                            />
                        </div>
                        <div className={styles.companyProfileUserFollowers}>
                            <a href="#!">
                                <strong>22</strong>
                                Followers
                            </a>

                            <a href="#!">
                                <strong>16</strong>
                                Following
                            </a>
                        </div>

                        <div className={styles.companyProfileUserContact}>
                            <Button
                                fontSize="0.75rem"
                                icon={images.mail}
                                alignImg="left"
                                classs="btnMain"
                                text="Email"
                            />
                            <Button
                                fontSize="0.75rem"
                                icon={images.phone}
                                alignImg="left"
                                classs="btnMain"
                                text="Phone"
                            />
                        </div>
                    </div>
                </section>

                <section className={styles.cardMain}>
                    <div className={styles.cardDescriptionsContent}>
                        <h4>About</h4>
                        <p>
                            At Revitalize Industries, we believe gathering
                            together creates stronger communities, cities,
                            countries, and planet. Join us on our mission to
                            revitalize our communities.
                        </p>
                    </div>

                    <div className={styles.cardDescriptionsFooter}>
                        <h4 className={styles.cardDescriptionsFooterText}>
                            <a onClick={() => setShowTaps(!showTaps)} href="#!">
                                See More
                            </a>
                        </h4>
                    </div>
                </section>

                {showTaps && (
                    <>
                        <section className={styles.cardMain}>
                            <nav className={styles.tabs}>
                                <a
                                    onClick={() => setTap(1)}
                                    className={tap === 1 ? styles.active : ''}
                                    href="#!">
                                    Posts
                                </a>
                                <a
                                    onClick={() => setTap(2)}
                                    href="#!"
                                    className={tap === 2 ? styles.active : ''}>
                                    Staff Directory
                                </a>
                                <a
                                    onClick={() => setTap(3)}
                                    className={tap === 3 ? styles.active : ''}
                                    href="#!">
                                    Resources
                                </a>
                            </nav>
                        </section>

                        <section className={styles.cardMainContent}>
                            {tap === 1 && (
                                <div style={{ height: 350 }}>
                                    <h1>Posts</h1>
                                </div>
                            )}
                            {tap === 2 && (
                                <div className={styles.gridContainer}>
                                    <CardPeoples
                                        image={images.userTest}
                                        name="Emma Mans"
                                        ocupation="Revitalize Industries"
                                    />
                                    <CardPeoples
                                        image={
                                            'https://modaellos.com//wp-content/uploads/2017/11/cortes-tipo-rostro-ovalado-istock.jpg'
                                        }
                                        name="Jacob Blanch"
                                        ocupation="Revitalize Industries"
                                    />
                                    <CardPeoples
                                        image={images.campfireSocialLogo}
                                        name="Logan Hall"
                                        ocupation="Revitalize Industries"
                                    />
                                    <CardPeoples
                                        image={images.campfireSocialLogo}
                                        name="Randy Palmer"
                                        ocupation="Revitalize Industries"
                                    />
                                    <CardPeoples
                                        image={images.campfireSocialLogo}
                                        name="Margaret Evers"
                                        ocupation="Account Executive at Won…"
                                    />
                                </div>
                            )}
                            {tap === 3 && (
                                <div style={{ height: 350 }}>
                                    <h1>Resources</h1>
                                </div>
                            )}
                        </section>
                    </>
                )}
            </div>
        </>
    );
};

export default Vendor;
